import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/startpage-logged-out/entry/src/recruiters-section/assets/maria-heucke.256x256.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')